import React from 'react';
import { connect } from 'react-redux';
import classNames from 'classnames';
import moment from 'moment';

import FormLabel from '@material-ui/core/FormLabel';
import MuiTextField from '@material-ui/core/TextField';
import withStyles from '@material-ui/core/styles/withStyles';

import Form from 'react-mui-lib/form-widgets/Form';
import TextField from 'react-mui-lib/form-widgets/TextField';

import Select from 'react-mui-lib/form-widgets/Select';
import ImageField from 'react-mui-lib/form-widgets/ImageUploadField';
import RadioList from 'react-mui-lib/form-widgets/RadioList';
import registry from 'react-mui-lib/registry';

import DatepickerField from '../locallib/DatepickerField';
import HelpButton from '../locallib/HelpButton';
import FieldWithHelp from '../locallib/FieldWithHelp';
import { has_superaccess } from '../utils';


const styles = {
    hidden: {
        display: 'none'
    },
    conditional_field_block: {
        borderLeft: '1px solid #666',
        paddingLeft: '24px'
    },
    dateFields: {
        display: 'flex',
        alignItems: 'flex-end',
        flexWrap: 'wrap'
    },
    dateFieldStart: {
        marginRight: '24px'
    },
    last_round_start_end_dates: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'flex-end'
    },
    last_round_end_date: {
        display: 'inline-flex',
        flexDirection: 'column'
    },
    last_round_end_date_title: {
        fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
        fontSize: '0.75rem',
        margin: '0 0 1em 0',
        color: 'rgba(0, 0, 0, 0.54)'
    },
    last_round_end_date_value: {
        margin: '0'
    }
};


class GameForm extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            authorFilter: ''
        };

        this.controller = registry.get('game_form_controller');
        this.franchise_list_controller = registry.get('franchise_list_controller');
    }

    getFranchiseOptions() {
        const c = this;
        const rows = (c.franchise_list_controller.state && c.franchise_list_controller.state.rows) || [];
        const filter = c.state.authorFilter.trim().toLowerCase();

        const filtered = filter ? rows.filter(fr => {
            const name = (fr.organizer_name || '').toLowerCase();
            const phone = (fr.organizer_phone || '').toLowerCase();
            const idName = (fr.name || '').toLowerCase();
            return name.indexOf(filter) !== -1 ||
                   phone.indexOf(filter) !== -1 ||
                   idName.indexOf(filter) !== -1;
        }) : rows;

        return filtered.map(fr => ({
            val: fr.id,
            label: c.franchise_list_controller.franchiseLabel(fr)
        })).sort((a, b) => a.label.localeCompare(b.label));
    }

    render() {
        const c = this;
        const { classes } = c.props;  // injected by withStyles()
        const plan = c.getSelectedPlan() || c.controller.getModel('plan').getModelValue();
        const isSuper = has_superaccess();
        const isNovice = !isSuper && plan === 'novice';
        const isSpecialist = !isSuper && plan === 'specialist';
        const isSpecialistPlus = !isSuper && plan === 'specialist_plus';
        const isProfi = !isSuper && plan === 'profi';
        const isExpert = !isSuper && plan === 'expert';
        const isLimited = isNovice || isSpecialist || isSpecialistPlus || isProfi;

        const disabledTooltip = 'Недоступно на данном тарифе';
        const optionLabel = (text, helpId, disabled) => (
            <span>
                <span title={disabled ? disabledTooltip : undefined}
                      style={{cursor: disabled ? 'not-allowed' : 'inherit'}}>
                    {text}
                </span>
                {' '}<HelpButton id={helpId} />
            </span>
        );

        const game_type_options = [{
            val: 'GAME',
            label: optionLabel('Квест', 'game_type_options.game', isSpecialist || isSpecialistPlus || isExpert),
            disabled: isSpecialist || isSpecialistPlus || isExpert
        }, {
            val: 'QUIZ',
            label: optionLabel('Квиз', 'game_type_options.quiz', isProfi || isExpert),
            disabled: isProfi || isExpert
        }, {
            val: 'TOUR',
            label: optionLabel('Экскурсия', 'game_type_options.tour', isLimited),
            disabled: isLimited
        }];

        const access_mode_options = [{
            val: 'PUBLIC',
            label: optionLabel('Открытая', 'access_mode.public', isNovice),
            disabled: isNovice
        }, {
            val: 'BY_INVITATION',
            label: optionLabel('По приглашению', 'access_mode.by_invitation', isNovice || isSpecialistPlus),
            disabled: isNovice || isSpecialistPlus
        }, {
            val: 'PRIVATE',
            label: optionLabel('Закрытая', 'access_mode.private', isNovice || isSpecialistPlus),
            disabled: isNovice || isSpecialistPlus
        }];

        const start_date_model = c.controller.getModel('start_date');
        const start_date_value = start_date_model.getViewValue();
        let end_date_min = undefined;
        let end_date_max = undefined;
        let end_date_max_message = undefined;
        if (start_date_value) {
            end_date_min = start_date_value.clone();
            if (!isSuper) {
                if (isNovice) {
                    end_date_max = start_date_value.clone().add(24, 'hours');
                    end_date_max_message = 'Для тарифа Новичок игра не может длиться более 24 часов';
                } else if (isSpecialist) {
                    end_date_max = start_date_value.clone().add(3, 'days');
                    end_date_max_message = 'Для тарифа Специалист игра не может длиться более 3 дней';
                } else if (isProfi) {
                    end_date_max = start_date_value.clone().add(7, 'days');
                    end_date_max_message = 'Для тарифа Профи игра не может длиться более 7 дней';
                } else if (isSpecialistPlus) {
                    end_date_max = start_date_value.clone().add(30, 'days');
                    end_date_max_message = 'Для тарифа Специалист+ игра не может длиться более 30 дней';
                }
            }
        }

        const round_mode_options = [{
            val: 'SEQUENCE',
            label: <span>По порядку <HelpButton id="round_mode.public" /></span>
        }, {
            val: 'RANDOM',
            label: <span>В случайном порядке <HelpButton id="round_mode.random" /></span>
        }, {
            val: 'SELECTABLE',
            label: <span>По выбору <HelpButton id="round_mode.selectable" /></span>
        }];

        return <div>
            <Form controller={c.controller}
                  title_new="Новая игра"
                  title_edit="Игра">

                <FieldWithHelp show={!c.controller.getModel('franchise_id').is('hidden')}>
                    <MuiTextField
                        label="Поиск автора"
                        placeholder="никнейм, телефон или маска"
                        value={c.state.authorFilter}
                        onChange={e => c.setState({ authorFilter: e.target.value })}
                        margin="normal"
                        fullWidth
                    />
                    <Select path="franchise_id"
                            options={c.getFranchiseOptions()}
                            label="Автор"/>
                </FieldWithHelp>

                <div>
                    <RadioList path="game_type"
                              label="Тип"
                              options={game_type_options} />
                </div>

                <FieldWithHelp>
                    <TextField path="name"
                               label="Название игры (не более 30 символов)" />
                    <HelpButton id="name" />
                </FieldWithHelp>
                <FieldWithHelp>
                    <TextField path="description"
                               label="Описание"
                               multiLine={true} />
                    <HelpButton id="description" />
                </FieldWithHelp>
                <FieldWithHelp>
                    <ImageField path="description_image"
                                config={{
                                    category: 'game-images',
                                    large_variant: '',
                                    enable_delete: false
                                }}
                                label="Изображение" />
                    <HelpButton id="description_image" />
                </FieldWithHelp>
                <FieldWithHelp>
                    <TextField path="location"
                               label="Место проведения" />
                    <HelpButton id="location" />
                </FieldWithHelp>
                <div className={classNames({
                    [classes.hidden]: c.controller.getModel('game_type').getModelValue() === 'TOUR'
                })}>
                    <FieldWithHelp>
                        <TextField path="prize"
                                label="Подарок" />
                        <HelpButton id="prize" />
                    </FieldWithHelp>
                </div>
                <FieldWithHelp>
                    <div className={classes.dateFields}>
                        <div className={classes.dateFieldStart}>
                            <DatepickerField path="start_date"
                                             label="Дата и время начала" />
                        </div>
                        <div>
                            <DatepickerField path="end_date"
                                             label="Дата и время окончания"
                                             minDate={end_date_min}
                                             maxDate={end_date_max}
                                             maxDateMessage={end_date_max_message} />
                        </div>
                    </div>
                    <HelpButton id="start-end-dates" />
                </FieldWithHelp>
                <div>
                    <RadioList path="access_mode"
                              label="Доступ"
                              options={access_mode_options} />
                </div>
                <div>
                    <RadioList path="round_mode"
                              label="Задания"
                              options={round_mode_options} />
                </div>
                <div className={classNames({
                    [classes.hidden]:
                        c.controller.getModel('round_mode').getModelValue() === '' || 
                        c.controller.getModel('game_type').getModelValue() === 'TOUR',
                    [classes.conditional_field_block]: true
                })}>
                    <div className={classNames({
                        [classes.hidden]: c.controller.getModel('round_mode').getModelValue() === 'SELECTABLE'
                    })}>
                        <TextField path="n_winners"
                                   label="Количество победителей"
                                   width="medium" />
                            <HelpButton id="n_winners" />
                    </div>
                    {/* last round start / end date */}
                    <div className={classNames({
                        [classes.hidden]: c.controller.getModel('round_mode').getModelValue() !== 'SELECTABLE'
                    })}>
                        <FormLabel component="legend">
                            Последнее задание
                        </FormLabel>
                        <div className={classes.last_round_start_end_dates}>
                            <DatepickerField path="last_round_start_date"
                                            label="Дата и время начала" />
                            &nbsp;&nbsp;&nbsp;
                            <div className={classes.last_round_end_date}>
                                <p className={classes.last_round_end_date_title}>
                                    Дата и время окончания
                                </p>
                                <p className={classes.last_round_end_date_value}>
                                    {c.controller.getModel('end_date').getViewValue().format('DD.MM.YYYY HH:mm')}
                                </p>
                            </div>
                            <HelpButton id="last-round-start-end-dates" />
                        </div>
                    </div>
                    <FieldWithHelp show={!c.controller.getModel('round_message').is('hidden')}>
                        <TextField path="round_message"
                                label="Сообщение в списке заданий"
                                multiLine={true} />
                        <HelpButton id="round_message" />
                    </FieldWithHelp>
                    <FieldWithHelp show={!c.controller.getModel('interim_message').is('hidden')}>
                        <TextField path="interim_message"
                                label="Сообщение до выбора победителей"
                                multiLine={true} />
                        <HelpButton id="interim_message" />
                    </FieldWithHelp>
                </div> {/* /conditional_field_block */}
                <FieldWithHelp>
                    <TextField path="finished_message"
                               label="Сообщение по окончании игры"
                               multiLine={true} />
                    <HelpButton id="finished_message" />
                </FieldWithHelp>
                <div className={classNames({
                    [classes.hidden]: c.controller.getModel('game_type').getModelValue() === 'TOUR'
                })}>
                    <FieldWithHelp>
                        <TextField path="winner_message"
                                label="Сообщение для победителей"
                                multiLine={true} />
                        <HelpButton id="winner_message" />
                    </FieldWithHelp>
                </div>
            </Form>
        </div>;
    }

    componentWillMount() {
        const c = this;
        const entity_id = c.props.match.params.id;

        if (entity_id === undefined) {
            const plan = c.getSelectedPlan();
            c.controller.editNew(plan ? getPlanInitialData(plan) : undefined);
        }
    }

    getSelectedPlan() {
        const search = this.props.location && this.props.location.search;
        if (!search) return null;
        const match = search.match(/[?&]plan=([^&]+)/);
        return match ? decodeURIComponent(match[1]) : null;
    }
}

function getPlanInitialData(plan) {
    const start_date = moment();

    if (plan === 'novice') {
        return {
            plan: 'novice',
            game_type: 'GAME',
            access_mode: 'PRIVATE',
            round_mode: 'SEQUENCE',
            n_winners: 5,
            start_date,
            end_date: start_date.clone().add(24, 'hours')
        };
    }

    if (plan === 'specialist') {
        return {
            plan: 'specialist',
            game_type: 'QUIZ',
            access_mode: 'PUBLIC',
            round_mode: 'SEQUENCE',
            n_winners: 5,
            start_date,
            end_date: start_date.clone().add(3, 'days')
        };
    }

    if (plan === 'specialist_plus') {
        return {
            plan: 'specialist_plus',
            game_type: 'QUIZ',
            access_mode: 'PUBLIC',
            round_mode: 'SEQUENCE',
            n_winners: 5,
            start_date,
            end_date: start_date.clone().add(30, 'days')
        };
    }

    if (plan === 'profi') {
        return {
            plan: 'profi',
            game_type: 'GAME',
            access_mode: 'PUBLIC',
            round_mode: 'SEQUENCE',
            n_winners: 5,
            start_date,
            end_date: start_date.clone().add(7, 'days')
        };
    }

    if (plan === 'expert') {
        return {
            plan: 'expert',
            game_type: 'TOUR',
            access_mode: 'PUBLIC',
            round_mode: 'SELECTABLE',
            start_date,
            end_date: start_date.clone().add(30, 'days')
        };
    }

    return null;
}

export default connect(
    /* mapStateToProps */ state => ({
        state__: state
    }),
    /* mapDispatchToProps */ state => ({
    })
)(withStyles(styles)(GameForm));
